import {createAction} from 'redux-act';

export const setLoginPhase = createAction('Set login phase', (phase) => ({phase}));
export const loginPhaseChanged = createAction('Login phase changed', (phase) => ({phase}));
